import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { ICommodity } from '../commodity/commodity';
import { ICommodityCondition } from './commodityCondition';
import { ICommodityConditionFormValues } from './commodityConditionFormValues';
import { ICommodityConditionUpsert } from './commodityConditionUpsert';
import { IOptionType } from '@zz2/zz2-ui';

export default class CommodityConditionModelHelper {
    public static createFormValues = (
        condition : ICommodityCondition | null,
        commodities : Array<ICommodity>
    ) : ICommodityConditionFormValues => {
        if (!condition) return {
            id: 0,
            guid: uuidV4(),
            condition: '',
            commodities: [],
            isActive: true,
        };

        const commoditiesOptions = commodities
            .filter(x => x.isActive && condition.commodityIds.includes(x.id))
            .map(x => { // TODO: OptionType.FromDataModel
                return {
                    value: x.id,
                    label: x.name,
                }
            });

        return {
            id: condition.id,
            guid: condition.guid,
            condition: condition.condition,
            commodities: commoditiesOptions,
            isActive: condition.isActive,
        };
    };

    public static createUpsert = (formValues : ICommodityConditionFormValues) : ICommodityConditionUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            condition: formValues.condition,
            commodityIds: formValues.commodities.map(x => Number(x.value)),
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<ICommodityConditionFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        condition: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        commodities: Yup.array<IOptionType>().defined().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
